<template>
  <div id="Table" class="Table">
    <div style="height: 600px; overflow-y: auto">
      <el-table ref="filterTable" :data="addressList" style="width: 100%" :height="500">
        <el-table-column v-for=" (item,index) in columeList" :key="index" :prop="item.field" :width="item.width"
          :label="item.value" :fixed="item.fixed">
          <template slot-scope="scope">
            {{ scope.row[item.field] }}
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="addressEdit(scope.row.id)"
              style="margin-right: 20px;">编辑</el-link>
            <el-link type="danger" :underline="false" @click="addressDelete(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.pageSize" layout="prev, pager, next"
      :total="total" style="margin-top: 25px" @current-change="handleCurrentChange" />
    <AddressEdit ref="AddressEdit" v-show="isAddressEdit" :isShow="isAddressEdit" @refresh="refresh" @close="refresh" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
import AddressEdit from './addressEdit.vue'
export default {
  name: 'Table',
  components: {
    AddressEdit
  },
  props: {
    // 父辈向子辈传参
    addrType: Number,
  },
  data () {
    return {
      token: '',
      addressList: [],
      columeList: [],
      total: 0,
      isAddressEdit: false,
      listQuery: {
        status: 0,
        addrType: 0,
        currentPage: 1,
        pageSize: 20,
        sort: 'desc',
        sidx: ''
      },
      businessType: 0
    }
  },
  watch: {},
  mounted () { },
  created () {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getAddressInfo()
      var columeList = JSON.parse(localStorage.getItem('columeList-address'));
      if (columeList != null) {
        this.columeList = columeList;
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getAddressInfo()
    },
    search () {
      this.listQuery.currentPage = 1
      this.getAddressInfo()
    },
    getAddressInfo () {
      this.listQuery.addrType = this.addrType;
      request({
        url: `/api/base/CstAddress`,
        method: 'GET',
        data: this.listQuery,
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.data != null) {
          this.addressList = res.data.list
          this.total = res.data.pagination.total
        }
      })
    },
    addressEdit (id) {
      this.isAddressEdit = true;
      this.$refs.AddressEdit.init(id)
    },
    addressDelete (id) {
      request({
        url: `/api/base/CstAddress/${id}`,
        method: 'delete',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.$message({
          message: res.msg,
          type: 'success'
        })
        this.getAddressInfo()
      })
    },
    refresh () {
      this.isAddressEdit = false;
      this.getAddressInfo();
    }
  }
}
</script>
<style lang="scss">
.tablepopover {
  min-width: 0px !important;
  padding: 0px !important;
  border: 0px !important;
}
</style>
<style scoped lang="scss">
::v-deep .el-table td {
  padding: 0px !important;
  border-bottom: 1px solid rgba(221, 221, 221, 0.56) !important;
  height: 37px;
  line-height: 37px;
}

::v-deep .el-table th {
  background: #f7f7f7;
  height: 32px !important;
  padding: 0px !important;
}

::v-deep .el-table__fixed,
.el-table__fixed-left {
  background-color: #fff !important;
  height: 500px !important;
}

::v-deep .el-table__fixed-right {
  background-color: #fff !important;
  height: 500px !important;
}

::v-deep .el-link.el-link--default {
  color: #3370ff;
}

::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  // width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  background: #e0e0e0;
}

::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  // -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  border-radius: 8px;
  background: #fff;
}

.columns-panle {
  width: 176px;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  position: absolute;
  top: -25px;
  left: -150px;
  z-index: 20;
  padding: 8px;

  .list-item {
    height: 30px;
    line-height: 30px;
    background: rgba(255, 255, 255, 0);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    cursor: pointer;

    &:hover {
      background: #f7f8fa;
      border-radius: 4px;
    }
  }
}
</style>
